const EXCLUDED = 'script, style, template, noscript, svg, math, textarea, input, select, [hidden], [aria-hidden="true"]';

export const htmlNodeAtPath = (root, path) =>
    Array.isArray(path) ? path.reduce((node, index) => node?.childNodes[index], root) : null;

const pathToNode = (root, node) => {
    const path = [];
    while (node && node !== root) {
        const parent = node.parentNode;
        if (!parent) return null;
        path.unshift(Array.from(parent.childNodes).indexOf(node));
        node = parent;
    }
    return node === root ? path : null;
};

const textNodes = element => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() && !node.parentElement?.closest(EXCLUDED)) nodes.push(node);
    }
    return nodes;
};

export const findHtmlTextPath = (root, target) => {
    const element = target?.nodeType === Node.TEXT_NODE ? target.parentElement : target;
    if (!element || element === root || !root.contains(element) || element.closest(EXCLUDED)) return null;
    return textNodes(element).length ? pathToNode(root, element) : null;
};

const parse = html => {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    return template;
};

export const getHtmlTextSelection = (html, path, preserveWhitespace = false) => {
    const { content } = parse(html);
    const element = htmlNodeAtPath(content, path);
    if (element?.nodeType !== Node.ELEMENT_NODE || element.closest(EXCLUDED)) return null;
    const texts = textNodes(element).map(node => ({
        path: pathToNode(content, node),
        value: preserveWhitespace ? node.nodeValue : node.nodeValue.trim(),
        tag: node.parentElement.tagName.toLowerCase(),
    }));
    return texts.length ? { tag: element.tagName.toLowerCase(), texts } : null;
};

export const updateHtmlTexts = (html, changes, keepEmptyNodes = false) => {
    const template = parse(html);
    for (const { path, value } of changes) {
        const node = htmlNodeAtPath(template.content, path);
        if (node?.nodeType !== Node.TEXT_NODE || node.parentElement?.closest(EXCLUDED)) continue;
        // Preserve the spacing separating inline tags, and never interpret the input as HTML.
        const leading = node.nodeValue.match(/^\s*/)[0];
        const trailing = node.nodeValue.match(/\s*$/)[0];
        node.nodeValue = keepEmptyNodes ? (value || ' ') : `${leading}${value}${trailing}`;
    }
    return template.innerHTML;
};
